document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".tabbed-section").forEach(function (section) {
    const toggles = section.querySelectorAll(".tabbed-section__toggle");
    const panels = section.querySelectorAll(".tabbed-section__content");

    toggles.forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        const view = toggle.getAttribute("data-view");
        if (!view) {
          return;
        }

        toggles.forEach(function (t) {
          t.classList.remove("--active");
        });
        toggle.classList.add("--active");

        panels.forEach(function (panel) {
          if (panel.getAttribute("data-view") === view) {
            panel.classList.add("--active");
          } else {
            panel.classList.remove("--active");
          }
        });
      });
    });
  });
});
